import { useCallback } from 'react';

import useTilesStore from 'state/tilesStore';

import { useRouter } from 'hooks/navigation';

/**
 * Sends the user back to /landing without a full page load, so the WebGL
 * canvases mounted in the root layout survive the navigation.
 *
 * The hard `window.location` navigations this replaces also wiped all client
 * state as a side effect. The 3D scene is the part that actually depends on
 * that, so clear the tile state explicitly: TilesScene watches it and tears
 * the tiles down on its own once `place` and `tileDefinitions` are empty.
 */
const useLandingRedirect = () => {
  const router = useRouter();

  return useCallback(() => {
    const { setPlace, setTileDefinitions } = useTilesStore.getState();

    setPlace(null);
    setTileDefinitions([]);

    router.replace('/landing');
  }, [router]);
};

export default useLandingRedirect;
